export enum MessageFilterTypes {
	UNREAD = 'unread',
	NEWEST = 'newest',
	OLDEST = 'oldest'
}
